import { SaleType } from "constants/sale";
import { DocumentTypeOption } from "constants/documentTypes";

export const filterBySaleType =
  (saleType: SaleType) => (option: DocumentTypeOption) =>
    !option.saleTypes || option.saleTypes.includes(saleType);
